import script from "./AddDataDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDataDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AddDataDrawer.vue?vue&type=style&index=0&id=be11dfc2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be11dfc2"]])

export default __exports__